<template>
  <v-dialog transition="dialog-bottom-transition" max-width="1200" v-model="visible" persistent>
    <v-card class="p-3">
      <v-card-title>
        <h2 class="mb-2">
          {{ $t("feedbackTitle") }}
        </h2>
      </v-card-title>
      <v-card-text class="card-content">
        <div class="question">
          <h4 class="question-text">{{ userType === "student" ? $t("Tutor") : $t("Student") }}</h4>
          <v-rating v-model="userRating" background-color="green lighten-3" color="green"
            class="question-rating"></v-rating>
        </div>
        <div class="question">
          <h4 class="question-text">{{ $t("platform") }}</h4>
          <v-rating v-model="platformRating" background-color="green lighten-3" color="green"
            class="question-rating"></v-rating>
        </div>
        <div class="question">
          <h4 class="question-text">{{ $t("service") }}</h4>
          <v-rating v-model="serviceRating" background-color="green lighten-3" color="green"
            class="question-rating"></v-rating>
        </div>
        <v-textarea class="mt-5" outlined color="green lighten-1" data-testId="comment-input" auto-grow
          :label="$t('leaveComment')" v-model="userComment"></v-textarea>
      </v-card-text>
      <v-card-actions class="actions-btn-group pe-6">
        <v-btn class="action-btn" data-testId="submit-btn" color="green lighten-1" @click="addFeedback">{{ $t("submit")
        }}</v-btn>
        <v-btn class="action-btn" data-testId="cancel-btn" color="red darken-3" @click="hideDialog">{{ $t("Cancel")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";

export default {
  name: "FeedbackModal",
  mixins: [GlobalMixin],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userRating: 0,
      platformRating: 0,
      serviceRating: 0,
      userComment: "",
      userType: JSON.parse(localStorage.getItem("vuex")).auth.user.user
        .user_type,
    };
  },
  methods: {
    hideDialog() {
      this.$emit("hideDialog", false);
    },

    async addFeedback() {
      if (!this.userRating || !this.platformRating || !this.serviceRating) {
        this.setAlert(
          "error",
          `${this.$t("Oops")}`,
          this.$t('addRate'),
          3000
        );
        return;
      }

      const body = {
        reservation_session: this.session.number,
        institute: JSON.parse(localStorage.getItem("institute_configs")).id,
        platform_rating: this.platformRating,
        service_rating: this.serviceRating,
        user_rating: this.userRating,
        comment: this.userComment,
      };

      await this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/submit_feedback/`,
          body,
          this.headers
        )
        .then((res) =>
          this.setAlert(
            "success",
            this.$t("messages.success"),
            res.data.message,
            2000
          )
        )
        .catch((err) => this.formatErrors(err));

      this.hideDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.question {
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 1rem;
  justify-items: center;

  .question-text {
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.87);
  }

  .question-rating {
    margin: auto;
  }
}

@media (min-width: 767px) {
  .question {
    grid-template-columns: 1fr auto;
    justify-items: normal;
  }
}

.actions-btn-group {
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.action-btn {
  color: #fff;
}
</style>
